// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdminGradingSystem_page__8l0wV { padding: 1.5rem; max-width: 1600px; margin: 0 auto; }

.AdminGradingSystem_header__W0uv1 { margin-bottom: 2rem; text-align: center; }
.AdminGradingSystem_title__WTWSK { font-size: 1.8rem; font-weight: 700; color: var(--black); margin-bottom: 0.4rem; }
.AdminGradingSystem_subtitle__XhcVQ { font-size: 0.9rem; color: var(--gray-600); font-weight: 500; }

.AdminGradingSystem_section__SBgHQ { margin-bottom: 1.5rem; }

.AdminGradingSystem_sectionHeader__XHRfi { margin-bottom: 1.2rem; }
.AdminGradingSystem_sectionTitle__6enf1 { font-size: 1.2rem; font-weight: 700; color: var(--black); margin-bottom: 0.3rem; }
.AdminGradingSystem_sectionDesc__\\+wuCa { font-size: 0.8rem; color: var(--gray-600); font-weight: 500; }

/* Section Scores Grid */
.AdminGradingSystem_sectionScoresGrid__l1omK { display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 1rem; }

.AdminGradingSystem_scoreCard__L6f-G { 
  background: white; 
  border: 1px solid var(--border); 
  border-radius: var(--radius-lg); 
  padding: 1.25rem; 
  display: flex; 
  gap: 0.85rem;
  transition: all 0.2s;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
}

.AdminGradingSystem_scoreCard__L6f-G:hover { 
  border-color: var(--green);
  box-shadow: 0 4px 12px rgba(26, 92, 56, 0.12);
}

.AdminGradingSystem_scoreNum__HKb\\+E {
  width: 42px;
  height: 42px;
  background: linear-gradient(135deg, var(--green) 0%, #2d8659 100%);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  font-weight: 700;
  flex-shrink: 0;
}

.AdminGradingSystem_scoreBody__HOsEk { display: flex; flex-direction: column; gap: 0.35rem; flex: 1 1; }

.AdminGradingSystem_scoreName__Q96I3 { font-size: 0.85rem; font-weight: 600; color: var(--gray-900); }
.AdminGradingSystem_scoreDesc__bpdhi { font-size: 0.75rem; color: var(--gray-600); line-height: 1.3; }
.AdminGradingSystem_scoreValue__qGcw3 { font-size: 1.1rem; font-weight: 700; color: var(--green); margin-top: 0.2rem; }

/* Grade Scale Table */
.AdminGradingSystem_gradeScaleTable__DDqtf { 
  background: white;
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  overflow: hidden;
}

.AdminGradingSystem_tableHeader__fjMRW {
  display: grid;
  grid-template-columns: 70px 1fr 1fr 1.8fr;
  gap: 0.8rem;
  padding: 1rem;
  background: linear-gradient(135deg, var(--gray-50) 0%, var(--gray-100) 100%);
  border-bottom: 2px solid var(--border);
  font-weight: 600;
  color: var(--gray-900);
  font-size: 0.85rem;
}

.AdminGradingSystem_tableRow__86jdu {
  display: grid;
  grid-template-columns: 70px 1fr 1fr 1.8fr;
  gap: 0.8rem;
  padding: 1rem;
  border-bottom: 1px solid var(--border);
  align-items: center;
}

.AdminGradingSystem_tableRow__86jdu:last-child { border-bottom: none; }
.AdminGradingSystem_tableRow__86jdu:hover { background: var(--gray-50); }

.AdminGradingSystem_colGrade__DVfCW, .AdminGradingSystem_colScore__OnuOI, .AdminGradingSystem_colPercent__TRQno, .AdminGradingSystem_colDesc__XgcFM { font-size: 0.85rem; color: var(--gray-700); }

.AdminGradingSystem_gradeBadge__OUYgR {
  width: 45px;
  height: 45px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 1.1rem;
  color: white;
}

/* Competency Table */
.AdminGradingSystem_competencyTable__MsMuY {
  background: white;
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  overflow: hidden;
}

.AdminGradingSystem_competencyTable__MsMuY .AdminGradingSystem_tableHeader__fjMRW {
  display: grid;
  grid-template-columns: 120px 100px 100px 100px 120px 100px 2fr;
  gap: 0.8rem;
  padding: 1.1rem;
  background: linear-gradient(135deg, var(--gray-50) 0%, var(--gray-100) 100%);
  border-bottom: 2px solid var(--border);
  font-weight: 700;
  color: var(--black);
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.AdminGradingSystem_competencyTable__MsMuY .AdminGradingSystem_tableRow__86jdu {
  display: grid;
  grid-template-columns: 120px 100px 100px 100px 120px 100px 2fr;
  gap: 0.8rem;
  padding: 1rem;
  border-bottom: 1px solid var(--border);
  align-items: flex-start;
  font-size: 0.85rem;
}

.AdminGradingSystem_competencyTable__MsMuY .AdminGradingSystem_tableRow__86jdu:last-child { border-bottom: none; }
.AdminGradingSystem_competencyTable__MsMuY .AdminGradingSystem_tableRow__86jdu:hover { background: var(--gray-50); }

.AdminGradingSystem_colCluster__E0tO9 {
  font-weight: 700;
  color: var(--black);
  font-size: 0.9rem;
}

.AdminGradingSystem_colQuestions__UhsYo {
  color: var(--gray-700);
  text-align: center;
  font-weight: 600;
}

.AdminGradingSystem_colMaxScore__Y1FSI {
  color: var(--gray-700);
  text-align: center;
  font-weight: 700;
}

.AdminGradingSystem_colStrong__gy1Uu {
  background: rgba(26, 150, 83, 0.08);
  padding: 0.5rem;
  border-radius: 6px;
  color: #1a5c38;
  font-weight: 700;
  text-align: center;
}

.AdminGradingSystem_colModerate__LyGvk {
  background: rgba(230, 126, 34, 0.08);
  padding: 0.5rem;
  border-radius: 6px;
  color: #c27d0e;
  font-weight: 700;
  text-align: center;
}

.AdminGradingSystem_colGap__vRMEg {
  background: rgba(192, 57, 43, 0.08);
  padding: 0.5rem;
  border-radius: 6px;
  color: #a93226;
  font-weight: 700;
  text-align: center;
}

.AdminGradingSystem_colMeasures__7IMS6 {
  color: var(--gray-700);
  line-height: 1.4;
  font-size: 0.8rem;
}

.AdminGradingSystem_competencyTable__MsMuY .AdminGradingSystem_tableHeader__fjMRW .AdminGradingSystem_colCluster__E0tO9,
.AdminGradingSystem_competencyTable__MsMuY .AdminGradingSystem_tableHeader__fjMRW .AdminGradingSystem_colQuestions__UhsYo,
.AdminGradingSystem_competencyTable__MsMuY .AdminGradingSystem_tableHeader__fjMRW .AdminGradingSystem_colMaxScore__Y1FSI,
.AdminGradingSystem_competencyTable__MsMuY .AdminGradingSystem_tableHeader__fjMRW .AdminGradingSystem_colStrong__gy1Uu,
.AdminGradingSystem_competencyTable__MsMuY .AdminGradingSystem_tableHeader__fjMRW .AdminGradingSystem_colModerate__LyGvk,
.AdminGradingSystem_competencyTable__MsMuY .AdminGradingSystem_tableHeader__fjMRW .AdminGradingSystem_colGap__vRMEg,
.AdminGradingSystem_competencyTable__MsMuY .AdminGradingSystem_tableHeader__fjMRW .AdminGradingSystem_colMeasures__7IMS6 {
  color: var(--black);
  background: transparent;
  font-size: 0.7rem;
}

/* Recommendations Grid */
.AdminGradingSystem_recommendationsGrid__kQgEu { display: grid; grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)); gap: 1.5rem; }

.AdminGradingSystem_recommendationCard__Mh8Ww {
  background: white;
  border: 1px solid var(--border);
  border-top: 5px solid;
  border-radius: var(--radius-lg);
  padding: 1.75rem;
  display: flex;
  gap: 1.25rem;
  transition: all 0.3s;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.AdminGradingSystem_recommendationCard__Mh8Ww:hover {
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.AdminGradingSystem_recIcon__FVQ\\+Z {
  width: 56px;
  height: 56px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.8rem;
  color: white;
  font-weight: 700;
  flex-shrink: 0;
}

.AdminGradingSystem_recContent__Do83\\+ { flex: 1 1; }

.AdminGradingSystem_recCategory__Nv\\+L3 { font-size: 1.1rem; font-weight: 700; color: var(--black); margin-bottom: 0.75rem; }

.AdminGradingSystem_recMetrics__aByw- { display: flex; flex-direction: column; gap: 0.5rem; margin-bottom: 1rem; }

.AdminGradingSystem_metricItem__WRuqm { display: flex; gap: 0.5rem; font-size: 0.9rem; }
.AdminGradingSystem_metricLabel__xLvbL { font-weight: 600; color: var(--gray-700); }
.AdminGradingSystem_metricValue__DquPe { color: var(--gray-900); font-weight: 700; }

.AdminGradingSystem_recDescription__sSJIu { font-size: 0.9rem; color: var(--gray-600); line-height: 1.5; }

/* Section 2 Guidance */
.AdminGradingSystem_section2GuideGrid__rKGP0 { display: grid; grid-template-columns: repeat(auto-fit, minmax(260px, 1fr)); gap: 1.2rem; margin-bottom: 1.5rem; }

.AdminGradingSystem_guideCard__O61J6 {
  background: white;
  border: 1px solid var(--border);
  border-top: 4px solid;
  border-radius: var(--radius-lg);
  padding: 1.5rem;
  transition: all 0.3s;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.AdminGradingSystem_guideCard__O61J6:hover {
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.AdminGradingSystem_guideHeader__pRC1n {
  color: white;
  padding: 0.65rem 0.85rem;
  border-radius: 6px;
  font-weight: 700;
  font-size: 0.9rem;
  margin-bottom: 0.85rem;
  text-align: center;
}

.AdminGradingSystem_guideScore__LNon7 {
  font-size: 1.6rem;
  font-weight: 700;
  color: var(--black);
  margin-bottom: 0.65rem;
  text-align: center;
}

.AdminGradingSystem_guideTitle__mWC8O {
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--gray-900);
  margin-bottom: 0.65rem;
  line-height: 1.3;
}

.AdminGradingSystem_guideDesc__3HzUy {
  font-size: 0.85rem;
  color: var(--gray-600);
  line-height: 1.5;
  margin-bottom: 0.85rem;
}

.AdminGradingSystem_guideInterpretation__VCf0d {
  padding: 0.65rem;
  background: var(--gray-50);
  border-left: 3px solid var(--gray-300);
  border-radius: 4px;
  font-size: 0.85rem;
  color: var(--gray-700);
  font-weight: 500;
}

/* Competency Profile */
.AdminGradingSystem_competencyGrid__WSZw8 { display: grid; grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)); gap: 0.8rem; }

.AdminGradingSystem_competencyCard__WI8H3 {
  background: white;
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  padding: 1.1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.55rem;
  text-align: center;
  transition: all 0.2s;
  cursor: pointer;
}

.AdminGradingSystem_competencyCard__WI8H3:hover {
  border-color: var(--green);
  box-shadow: 0 4px 12px rgba(26, 92, 56, 0.12);
  transform: translateY(-2px);
}

.AdminGradingSystem_compIcon__QnsCg { font-size: 1.75rem; }
.AdminGradingSystem_compName__KKN2z { font-size: 0.8rem; font-weight: 600; color: var(--gray-900); line-height: 1.2; }

/* Criteria Grid */
.AdminGradingSystem_criteriaGrid__iq19m { display: grid; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); gap: 1rem; }

.AdminGradingSystem_criteriaCard__FPLqP {
  background: linear-gradient(135deg, white 0%, var(--gray-50) 100%);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  padding: 1.4rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 0.85rem;
  transition: all 0.3s;
}

.AdminGradingSystem_criteriaCard__FPLqP:hover {
  border-color: var(--green);
  box-shadow: 0 8px 20px rgba(26, 92, 56, 0.1);
  transform: translateY(-3px);
}

.AdminGradingSystem_criteriaIcon__NMhCw { font-size: 2.2rem; }

.AdminGradingSystem_criteriaCard__FPLqP h3 { font-size: 0.95rem; font-weight: 700; color: var(--black); margin-bottom: 0.3rem; }
.AdminGradingSystem_criteriaCard__FPLqP p { font-size: 0.8rem; color: var(--gray-600); line-height: 1.4; }

/* Notes Container */
.AdminGradingSystem_notesContainer__ZBj3V { display: flex; flex-direction: column; gap: 0.8rem; }

.AdminGradingSystem_note__cCn-L {
  background: linear-gradient(135deg, var(--green-light) 0%, rgba(26, 92, 56, 0.05) 100%);
  border: 1px solid rgba(26, 92, 56, 0.2);
  border-left: 4px solid var(--green);
  border-radius: var(--radius-lg);
  padding: 1rem;
  display: flex;
  gap: 0.85rem;
}

.AdminGradingSystem_noteIcon__O\\+w2j {
  color: var(--green);
  font-size: 1rem;
  font-weight: 700;
  flex-shrink: 0;
  margin-top: 2px;
}

.AdminGradingSystem_noteText__bW5x8 { font-size: 0.85rem; color: var(--gray-700); line-height: 1.5; }

/* Responsive */
@media (max-width: 1024px) {
  .AdminGradingSystem_page__8l0wV { padding: 1.5rem; }
  .AdminGradingSystem_sectionScoresGrid__l1omK { grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)); gap: 1rem; }
  .AdminGradingSystem_section2GuideGrid__rKGP0 { grid-template-columns: 1fr; }
  .AdminGradingSystem_tableHeader__fjMRW, .AdminGradingSystem_tableRow__86jdu { grid-template-columns: 70px 1fr 1fr 1.5fr; gap: 0.8rem; padding: 1rem; }
  .AdminGradingSystem_competencyTable__MsMuY .AdminGradingSystem_tableHeader__fjMRW,
  .AdminGradingSystem_competencyTable__MsMuY .AdminGradingSystem_tableRow__86jdu {
    grid-template-columns: 100px 80px 80px 80px 100px 80px 1fr;
    gap: 0.6rem;
  }
  .AdminGradingSystem_title__WTWSK { font-size: 1.8rem; }
}

@media (max-width: 768px) {
  .AdminGradingSystem_page__8l0wV { padding: 1rem; }
  .AdminGradingSystem_sectionScoresGrid__l1omK { grid-template-columns: 1fr; }
  .AdminGradingSystem_tableHeader__fjMRW, .AdminGradingSystem_tableRow__86jdu { grid-template-columns: 1fr; gap: 0.5rem; padding: 0.9rem; }
  .AdminGradingSystem_tableHeader__fjMRW { display: flex; flex-wrap: wrap; }
  .AdminGradingSystem_tableRow__86jdu { display: grid; grid-template-columns: repeat(2, 1fr); }
  .AdminGradingSystem_competencyTable__MsMuY .AdminGradingSystem_tableHeader__fjMRW,
  .AdminGradingSystem_competencyTable__MsMuY .AdminGradingSystem_tableRow__86jdu {
    grid-template-columns: 1fr;
    gap: 0.5rem;
    padding: 0.8rem;
  }
  .AdminGradingSystem_competencyGrid__WSZw8 { grid-template-columns: repeat(2, 1fr); }
  .AdminGradingSystem_criteriaGrid__iq19m { grid-template-columns: 1fr; }
  .AdminGradingSystem_title__WTWSK { font-size: 1.5rem; }
  .AdminGradingSystem_sectionTitle__6enf1 { font-size: 1.2rem; }
}

@media (max-width: 480px) {
  .AdminGradingSystem_page__8l0wV { padding: 0.75rem; }
  .AdminGradingSystem_header__W0uv1 { margin-bottom: 1.5rem; }
  .AdminGradingSystem_title__WTWSK { font-size: 1.3rem; }
  .AdminGradingSystem_subtitle__XhcVQ { font-size: 0.85rem; }
  .AdminGradingSystem_section__SBgHQ { margin-bottom: 1.5rem; }
  .AdminGradingSystem_sectionTitle__6enf1 { font-size: 1.1rem; }
  .AdminGradingSystem_scoreCard__L6f-G { flex-direction: column; }
  .AdminGradingSystem_scoreNum__HKb\\+E { width: 40px; height: 40px; font-size: 1.1rem; }
  .AdminGradingSystem_competencyGrid__WSZw8 { grid-template-columns: 1fr; }
  .AdminGradingSystem_recommendationCard__Mh8Ww { flex-direction: column; }
  .AdminGradingSystem_recIcon__FVQ\\+Z { width: 48px; height: 48px; font-size: 1.5rem; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/AdminGradingSystem.module.css"],"names":[],"mappings":"AAAA,kCAAQ,eAAe,EAAE,iBAAiB,EAAE,cAAc,EAAE;;AAE5D,oCAAU,mBAAmB,EAAE,kBAAkB,EAAE;AACnD,mCAAS,iBAAiB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,qBAAqB,EAAE;AAC1F,sCAAY,iBAAiB,EAAE,sBAAsB,EAAE,gBAAgB,EAAE;;AAEzE,qCAAW,qBAAqB,EAAE;;AAElC,2CAAiB,qBAAqB,EAAE;AACxC,0CAAgB,iBAAiB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,qBAAqB,EAAE;AACjG,0CAAe,iBAAiB,EAAE,sBAAsB,EAAE,gBAAgB,EAAE;;AAE5E,wBAAwB;AACxB,+CAAqB,aAAa,EAAE,2DAA2D,EAAE,SAAS,EAAE;;AAE5G;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,+BAA+B;EAC/B,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,0BAA0B;EAC1B,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kEAAkE;EAClE,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,uCAAa,aAAa,EAAE,sBAAsB,EAAE,YAAY,EAAE,SAAO,EAAE;;AAE3E,uCAAa,kBAAkB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE;AAC3E,uCAAa,kBAAkB,EAAE,sBAAsB,EAAE,gBAAgB,EAAE;AAC3E,wCAAc,iBAAiB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;;AAE5F,sBAAsB;AACtB;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yCAAyC;EACzC,WAAW;EACX,aAAa;EACb,4EAA4E;EAC5E,sCAAsC;EACtC,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yCAAyC;EACzC,WAAW;EACX,aAAa;EACb,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA,iDAAuB,mBAAmB,EAAE;AAC5C,4CAAkB,0BAA0B,EAAE;;AAE9C,sJAA8C,kBAAkB,EAAE,sBAAsB,EAAE;;AAE1F;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8DAA8D;EAC9D,WAAW;EACX,eAAe;EACf,4EAA4E;EAC5E,sCAAsC;EACtC,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8DAA8D;EAC9D,WAAW;EACX,aAAa;EACb,sCAAsC;EACtC,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,4FAAwC,mBAAmB,EAAE;AAC7D,uFAAmC,0BAA0B,EAAE;;AAE/D;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;;;;;;EAOE,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB,iDAAuB,aAAa,EAAE,2DAA2D,EAAE,WAAW,EAAE;;AAEhH;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,qBAAqB;EACrB,+BAA+B;EAC/B,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;;AAEA,yCAAc,SAAO,EAAE;;AAEvB,0CAAe,iBAAiB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,sBAAsB,EAAE;;AAEjG,wCAAc,aAAa,EAAE,sBAAsB,EAAE,WAAW,EAAE,mBAAmB,EAAE;;AAEvF,wCAAc,aAAa,EAAE,WAAW,EAAE,iBAAiB,EAAE;AAC7D,yCAAe,gBAAgB,EAAE,sBAAsB,EAAE;AACzD,yCAAe,sBAAsB,EAAE,gBAAgB,EAAE;;AAEzD,4CAAkB,iBAAiB,EAAE,sBAAsB,EAAE,gBAAgB,EAAE;;AAE/E,uBAAuB;AACvB,+CAAqB,aAAa,EAAE,2DAA2D,EAAE,WAAW,EAAE,qBAAqB,EAAE;;AAErI;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,qBAAqB;EACrB,+BAA+B;EAC/B,eAAe;EACf,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,sCAAsC;EACtC,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB,4CAAkB,aAAa,EAAE,2DAA2D,EAAE,WAAW,EAAE;;AAE3G;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,+BAA+B;EAC/B,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA,sCAAY,kBAAkB,EAAE;AAChC,sCAAY,iBAAiB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,gBAAgB,EAAE;;AAE3F,kBAAkB;AAClB,0CAAgB,aAAa,EAAE,2DAA2D,EAAE,SAAS,EAAE;;AAEvG;EACE,kEAAkE;EAClE,+BAA+B;EAC/B,+BAA+B;EAC/B,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA,0CAAgB,iBAAiB,EAAE;;AAEnC,6CAAmB,kBAAkB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,qBAAqB,EAAE;AACrG,4CAAkB,iBAAiB,EAAE,sBAAsB,EAAE,gBAAgB,EAAE;;AAE/E,oBAAoB;AACpB,4CAAkB,aAAa,EAAE,sBAAsB,EAAE,WAAW,EAAE;;AAEtE;EACE,uFAAuF;EACvF,uCAAuC;EACvC,mCAAmC;EACnC,+BAA+B;EAC/B,aAAa;EACb,aAAa;EACb,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA,sCAAY,kBAAkB,EAAE,sBAAsB,EAAE,gBAAgB,EAAE;;AAE1E,eAAe;AACf;EACE,kCAAQ,eAAe,EAAE;EACzB,+CAAqB,2DAA2D,EAAE,SAAS,EAAE;EAC7F,+CAAqB,0BAA0B,EAAE;EACjD,8EAA0B,yCAAyC,EAAE,WAAW,EAAE,aAAa,EAAE;EACjG;;IAEE,0DAA0D;IAC1D,WAAW;EACb;EACA,mCAAS,iBAAiB,EAAE;AAC9B;;AAEA;EACE,kCAAQ,aAAa,EAAE;EACvB,+CAAqB,0BAA0B,EAAE;EACjD,8EAA0B,0BAA0B,EAAE,WAAW,EAAE,eAAe,EAAE;EACpF,yCAAe,aAAa,EAAE,eAAe,EAAE;EAC/C,sCAAY,aAAa,EAAE,qCAAqC,EAAE;EAClE;;IAEE,0BAA0B;IAC1B,WAAW;IACX,eAAe;EACjB;EACA,4CAAkB,qCAAqC,EAAE;EACzD,0CAAgB,0BAA0B,EAAE;EAC5C,mCAAS,iBAAiB,EAAE;EAC5B,0CAAgB,iBAAiB,EAAE;AACrC;;AAEA;EACE,kCAAQ,gBAAgB,EAAE;EAC1B,oCAAU,qBAAqB,EAAE;EACjC,mCAAS,iBAAiB,EAAE;EAC5B,sCAAY,kBAAkB,EAAE;EAChC,qCAAW,qBAAqB,EAAE;EAClC,0CAAgB,iBAAiB,EAAE;EACnC,uCAAa,sBAAsB,EAAE;EACrC,uCAAY,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE;EAC1D,4CAAkB,0BAA0B,EAAE;EAC9C,gDAAsB,sBAAsB,EAAE;EAC9C,sCAAW,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE;AAC3D","sourcesContent":[".page { padding: 1.5rem; max-width: 1600px; margin: 0 auto; }\n\n.header { margin-bottom: 2rem; text-align: center; }\n.title { font-size: 1.8rem; font-weight: 700; color: var(--black); margin-bottom: 0.4rem; }\n.subtitle { font-size: 0.9rem; color: var(--gray-600); font-weight: 500; }\n\n.section { margin-bottom: 1.5rem; }\n\n.sectionHeader { margin-bottom: 1.2rem; }\n.sectionTitle { font-size: 1.2rem; font-weight: 700; color: var(--black); margin-bottom: 0.3rem; }\n.sectionDesc { font-size: 0.8rem; color: var(--gray-600); font-weight: 500; }\n\n/* Section Scores Grid */\n.sectionScoresGrid { display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 1rem; }\n\n.scoreCard { \n  background: white; \n  border: 1px solid var(--border); \n  border-radius: var(--radius-lg); \n  padding: 1.25rem; \n  display: flex; \n  gap: 0.85rem;\n  transition: all 0.2s;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);\n}\n\n.scoreCard:hover { \n  border-color: var(--green);\n  box-shadow: 0 4px 12px rgba(26, 92, 56, 0.12);\n}\n\n.scoreNum {\n  width: 42px;\n  height: 42px;\n  background: linear-gradient(135deg, var(--green) 0%, #2d8659 100%);\n  color: white;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.2rem;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.scoreBody { display: flex; flex-direction: column; gap: 0.35rem; flex: 1; }\n\n.scoreName { font-size: 0.85rem; font-weight: 600; color: var(--gray-900); }\n.scoreDesc { font-size: 0.75rem; color: var(--gray-600); line-height: 1.3; }\n.scoreValue { font-size: 1.1rem; font-weight: 700; color: var(--green); margin-top: 0.2rem; }\n\n/* Grade Scale Table */\n.gradeScaleTable { \n  background: white;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n}\n\n.tableHeader {\n  display: grid;\n  grid-template-columns: 70px 1fr 1fr 1.8fr;\n  gap: 0.8rem;\n  padding: 1rem;\n  background: linear-gradient(135deg, var(--gray-50) 0%, var(--gray-100) 100%);\n  border-bottom: 2px solid var(--border);\n  font-weight: 600;\n  color: var(--gray-900);\n  font-size: 0.85rem;\n}\n\n.tableRow {\n  display: grid;\n  grid-template-columns: 70px 1fr 1fr 1.8fr;\n  gap: 0.8rem;\n  padding: 1rem;\n  border-bottom: 1px solid var(--border);\n  align-items: center;\n}\n\n.tableRow:last-child { border-bottom: none; }\n.tableRow:hover { background: var(--gray-50); }\n\n.colGrade, .colScore, .colPercent, .colDesc { font-size: 0.85rem; color: var(--gray-700); }\n\n.gradeBadge {\n  width: 45px;\n  height: 45px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  font-size: 1.1rem;\n  color: white;\n}\n\n/* Competency Table */\n.competencyTable {\n  background: white;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n}\n\n.competencyTable .tableHeader {\n  display: grid;\n  grid-template-columns: 120px 100px 100px 100px 120px 100px 2fr;\n  gap: 0.8rem;\n  padding: 1.1rem;\n  background: linear-gradient(135deg, var(--gray-50) 0%, var(--gray-100) 100%);\n  border-bottom: 2px solid var(--border);\n  font-weight: 700;\n  color: var(--black);\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.competencyTable .tableRow {\n  display: grid;\n  grid-template-columns: 120px 100px 100px 100px 120px 100px 2fr;\n  gap: 0.8rem;\n  padding: 1rem;\n  border-bottom: 1px solid var(--border);\n  align-items: flex-start;\n  font-size: 0.85rem;\n}\n\n.competencyTable .tableRow:last-child { border-bottom: none; }\n.competencyTable .tableRow:hover { background: var(--gray-50); }\n\n.colCluster {\n  font-weight: 700;\n  color: var(--black);\n  font-size: 0.9rem;\n}\n\n.colQuestions {\n  color: var(--gray-700);\n  text-align: center;\n  font-weight: 600;\n}\n\n.colMaxScore {\n  color: var(--gray-700);\n  text-align: center;\n  font-weight: 700;\n}\n\n.colStrong {\n  background: rgba(26, 150, 83, 0.08);\n  padding: 0.5rem;\n  border-radius: 6px;\n  color: #1a5c38;\n  font-weight: 700;\n  text-align: center;\n}\n\n.colModerate {\n  background: rgba(230, 126, 34, 0.08);\n  padding: 0.5rem;\n  border-radius: 6px;\n  color: #c27d0e;\n  font-weight: 700;\n  text-align: center;\n}\n\n.colGap {\n  background: rgba(192, 57, 43, 0.08);\n  padding: 0.5rem;\n  border-radius: 6px;\n  color: #a93226;\n  font-weight: 700;\n  text-align: center;\n}\n\n.colMeasures {\n  color: var(--gray-700);\n  line-height: 1.4;\n  font-size: 0.8rem;\n}\n\n.competencyTable .tableHeader .colCluster,\n.competencyTable .tableHeader .colQuestions,\n.competencyTable .tableHeader .colMaxScore,\n.competencyTable .tableHeader .colStrong,\n.competencyTable .tableHeader .colModerate,\n.competencyTable .tableHeader .colGap,\n.competencyTable .tableHeader .colMeasures {\n  color: var(--black);\n  background: transparent;\n  font-size: 0.7rem;\n}\n\n/* Recommendations Grid */\n.recommendationsGrid { display: grid; grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)); gap: 1.5rem; }\n\n.recommendationCard {\n  background: white;\n  border: 1px solid var(--border);\n  border-top: 5px solid;\n  border-radius: var(--radius-lg);\n  padding: 1.75rem;\n  display: flex;\n  gap: 1.25rem;\n  transition: all 0.3s;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.recommendationCard:hover {\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);\n  transform: translateY(-2px);\n}\n\n.recIcon {\n  width: 56px;\n  height: 56px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.8rem;\n  color: white;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.recContent { flex: 1; }\n\n.recCategory { font-size: 1.1rem; font-weight: 700; color: var(--black); margin-bottom: 0.75rem; }\n\n.recMetrics { display: flex; flex-direction: column; gap: 0.5rem; margin-bottom: 1rem; }\n\n.metricItem { display: flex; gap: 0.5rem; font-size: 0.9rem; }\n.metricLabel { font-weight: 600; color: var(--gray-700); }\n.metricValue { color: var(--gray-900); font-weight: 700; }\n\n.recDescription { font-size: 0.9rem; color: var(--gray-600); line-height: 1.5; }\n\n/* Section 2 Guidance */\n.section2GuideGrid { display: grid; grid-template-columns: repeat(auto-fit, minmax(260px, 1fr)); gap: 1.2rem; margin-bottom: 1.5rem; }\n\n.guideCard {\n  background: white;\n  border: 1px solid var(--border);\n  border-top: 4px solid;\n  border-radius: var(--radius-lg);\n  padding: 1.5rem;\n  transition: all 0.3s;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.guideCard:hover {\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);\n  transform: translateY(-2px);\n}\n\n.guideHeader {\n  color: white;\n  padding: 0.65rem 0.85rem;\n  border-radius: 6px;\n  font-weight: 700;\n  font-size: 0.9rem;\n  margin-bottom: 0.85rem;\n  text-align: center;\n}\n\n.guideScore {\n  font-size: 1.6rem;\n  font-weight: 700;\n  color: var(--black);\n  margin-bottom: 0.65rem;\n  text-align: center;\n}\n\n.guideTitle {\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: var(--gray-900);\n  margin-bottom: 0.65rem;\n  line-height: 1.3;\n}\n\n.guideDesc {\n  font-size: 0.85rem;\n  color: var(--gray-600);\n  line-height: 1.5;\n  margin-bottom: 0.85rem;\n}\n\n.guideInterpretation {\n  padding: 0.65rem;\n  background: var(--gray-50);\n  border-left: 3px solid var(--gray-300);\n  border-radius: 4px;\n  font-size: 0.85rem;\n  color: var(--gray-700);\n  font-weight: 500;\n}\n\n/* Competency Profile */\n.competencyGrid { display: grid; grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)); gap: 0.8rem; }\n\n.competencyCard {\n  background: white;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  padding: 1.1rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.55rem;\n  text-align: center;\n  transition: all 0.2s;\n  cursor: pointer;\n}\n\n.competencyCard:hover {\n  border-color: var(--green);\n  box-shadow: 0 4px 12px rgba(26, 92, 56, 0.12);\n  transform: translateY(-2px);\n}\n\n.compIcon { font-size: 1.75rem; }\n.compName { font-size: 0.8rem; font-weight: 600; color: var(--gray-900); line-height: 1.2; }\n\n/* Criteria Grid */\n.criteriaGrid { display: grid; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); gap: 1rem; }\n\n.criteriaCard {\n  background: linear-gradient(135deg, white 0%, var(--gray-50) 100%);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  padding: 1.4rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: 0.85rem;\n  transition: all 0.3s;\n}\n\n.criteriaCard:hover {\n  border-color: var(--green);\n  box-shadow: 0 8px 20px rgba(26, 92, 56, 0.1);\n  transform: translateY(-3px);\n}\n\n.criteriaIcon { font-size: 2.2rem; }\n\n.criteriaCard h3 { font-size: 0.95rem; font-weight: 700; color: var(--black); margin-bottom: 0.3rem; }\n.criteriaCard p { font-size: 0.8rem; color: var(--gray-600); line-height: 1.4; }\n\n/* Notes Container */\n.notesContainer { display: flex; flex-direction: column; gap: 0.8rem; }\n\n.note {\n  background: linear-gradient(135deg, var(--green-light) 0%, rgba(26, 92, 56, 0.05) 100%);\n  border: 1px solid rgba(26, 92, 56, 0.2);\n  border-left: 4px solid var(--green);\n  border-radius: var(--radius-lg);\n  padding: 1rem;\n  display: flex;\n  gap: 0.85rem;\n}\n\n.noteIcon {\n  color: var(--green);\n  font-size: 1rem;\n  font-weight: 700;\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.noteText { font-size: 0.85rem; color: var(--gray-700); line-height: 1.5; }\n\n/* Responsive */\n@media (max-width: 1024px) {\n  .page { padding: 1.5rem; }\n  .sectionScoresGrid { grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)); gap: 1rem; }\n  .section2GuideGrid { grid-template-columns: 1fr; }\n  .tableHeader, .tableRow { grid-template-columns: 70px 1fr 1fr 1.5fr; gap: 0.8rem; padding: 1rem; }\n  .competencyTable .tableHeader,\n  .competencyTable .tableRow {\n    grid-template-columns: 100px 80px 80px 80px 100px 80px 1fr;\n    gap: 0.6rem;\n  }\n  .title { font-size: 1.8rem; }\n}\n\n@media (max-width: 768px) {\n  .page { padding: 1rem; }\n  .sectionScoresGrid { grid-template-columns: 1fr; }\n  .tableHeader, .tableRow { grid-template-columns: 1fr; gap: 0.5rem; padding: 0.9rem; }\n  .tableHeader { display: flex; flex-wrap: wrap; }\n  .tableRow { display: grid; grid-template-columns: repeat(2, 1fr); }\n  .competencyTable .tableHeader,\n  .competencyTable .tableRow {\n    grid-template-columns: 1fr;\n    gap: 0.5rem;\n    padding: 0.8rem;\n  }\n  .competencyGrid { grid-template-columns: repeat(2, 1fr); }\n  .criteriaGrid { grid-template-columns: 1fr; }\n  .title { font-size: 1.5rem; }\n  .sectionTitle { font-size: 1.2rem; }\n}\n\n@media (max-width: 480px) {\n  .page { padding: 0.75rem; }\n  .header { margin-bottom: 1.5rem; }\n  .title { font-size: 1.3rem; }\n  .subtitle { font-size: 0.85rem; }\n  .section { margin-bottom: 1.5rem; }\n  .sectionTitle { font-size: 1.1rem; }\n  .scoreCard { flex-direction: column; }\n  .scoreNum { width: 40px; height: 40px; font-size: 1.1rem; }\n  .competencyGrid { grid-template-columns: 1fr; }\n  .recommendationCard { flex-direction: column; }\n  .recIcon { width: 48px; height: 48px; font-size: 1.5rem; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `AdminGradingSystem_page__8l0wV`,
	"header": `AdminGradingSystem_header__W0uv1`,
	"title": `AdminGradingSystem_title__WTWSK`,
	"subtitle": `AdminGradingSystem_subtitle__XhcVQ`,
	"section": `AdminGradingSystem_section__SBgHQ`,
	"sectionHeader": `AdminGradingSystem_sectionHeader__XHRfi`,
	"sectionTitle": `AdminGradingSystem_sectionTitle__6enf1`,
	"sectionDesc": `AdminGradingSystem_sectionDesc__+wuCa`,
	"sectionScoresGrid": `AdminGradingSystem_sectionScoresGrid__l1omK`,
	"scoreCard": `AdminGradingSystem_scoreCard__L6f-G`,
	"scoreNum": `AdminGradingSystem_scoreNum__HKb+E`,
	"scoreBody": `AdminGradingSystem_scoreBody__HOsEk`,
	"scoreName": `AdminGradingSystem_scoreName__Q96I3`,
	"scoreDesc": `AdminGradingSystem_scoreDesc__bpdhi`,
	"scoreValue": `AdminGradingSystem_scoreValue__qGcw3`,
	"gradeScaleTable": `AdminGradingSystem_gradeScaleTable__DDqtf`,
	"tableHeader": `AdminGradingSystem_tableHeader__fjMRW`,
	"tableRow": `AdminGradingSystem_tableRow__86jdu`,
	"colGrade": `AdminGradingSystem_colGrade__DVfCW`,
	"colScore": `AdminGradingSystem_colScore__OnuOI`,
	"colPercent": `AdminGradingSystem_colPercent__TRQno`,
	"colDesc": `AdminGradingSystem_colDesc__XgcFM`,
	"gradeBadge": `AdminGradingSystem_gradeBadge__OUYgR`,
	"competencyTable": `AdminGradingSystem_competencyTable__MsMuY`,
	"colCluster": `AdminGradingSystem_colCluster__E0tO9`,
	"colQuestions": `AdminGradingSystem_colQuestions__UhsYo`,
	"colMaxScore": `AdminGradingSystem_colMaxScore__Y1FSI`,
	"colStrong": `AdminGradingSystem_colStrong__gy1Uu`,
	"colModerate": `AdminGradingSystem_colModerate__LyGvk`,
	"colGap": `AdminGradingSystem_colGap__vRMEg`,
	"colMeasures": `AdminGradingSystem_colMeasures__7IMS6`,
	"recommendationsGrid": `AdminGradingSystem_recommendationsGrid__kQgEu`,
	"recommendationCard": `AdminGradingSystem_recommendationCard__Mh8Ww`,
	"recIcon": `AdminGradingSystem_recIcon__FVQ+Z`,
	"recContent": `AdminGradingSystem_recContent__Do83+`,
	"recCategory": `AdminGradingSystem_recCategory__Nv+L3`,
	"recMetrics": `AdminGradingSystem_recMetrics__aByw-`,
	"metricItem": `AdminGradingSystem_metricItem__WRuqm`,
	"metricLabel": `AdminGradingSystem_metricLabel__xLvbL`,
	"metricValue": `AdminGradingSystem_metricValue__DquPe`,
	"recDescription": `AdminGradingSystem_recDescription__sSJIu`,
	"section2GuideGrid": `AdminGradingSystem_section2GuideGrid__rKGP0`,
	"guideCard": `AdminGradingSystem_guideCard__O61J6`,
	"guideHeader": `AdminGradingSystem_guideHeader__pRC1n`,
	"guideScore": `AdminGradingSystem_guideScore__LNon7`,
	"guideTitle": `AdminGradingSystem_guideTitle__mWC8O`,
	"guideDesc": `AdminGradingSystem_guideDesc__3HzUy`,
	"guideInterpretation": `AdminGradingSystem_guideInterpretation__VCf0d`,
	"competencyGrid": `AdminGradingSystem_competencyGrid__WSZw8`,
	"competencyCard": `AdminGradingSystem_competencyCard__WI8H3`,
	"compIcon": `AdminGradingSystem_compIcon__QnsCg`,
	"compName": `AdminGradingSystem_compName__KKN2z`,
	"criteriaGrid": `AdminGradingSystem_criteriaGrid__iq19m`,
	"criteriaCard": `AdminGradingSystem_criteriaCard__FPLqP`,
	"criteriaIcon": `AdminGradingSystem_criteriaIcon__NMhCw`,
	"notesContainer": `AdminGradingSystem_notesContainer__ZBj3V`,
	"note": `AdminGradingSystem_note__cCn-L`,
	"noteIcon": `AdminGradingSystem_noteIcon__O+w2j`,
	"noteText": `AdminGradingSystem_noteText__bW5x8`
};
export default ___CSS_LOADER_EXPORT___;
